import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import AvpNodeContentSection from './AvpNodeContentSection';
import AvpNodePropertiesSection from './AvpNodePropertiesSection';

const AvpNodeSection = forwardRef((props, ref) => {
  const nodePropertyRef = useRef();
  const nodeContentRef = useRef();

  const [selectedNode, setSelectedNode] = useState(null);

  useEffect(() => {
    setSelectedNode(props.node);
  }, [props.node]);  // Aggiorna selectedNode solo quando props.node cambia

  useImperativeHandle(ref, () => ({
    getData() {
      return getNodeData();
    }
  }));

  function getNodeData() {
    const propData = nodePropertyRef.current?.getData ? nodePropertyRef.current.getData() : null;
    const contentData = nodeContentRef.current?.getData ? nodeContentRef.current.getData() : null;

    return {
      props: propData,
      avatar: contentData
    };
  }

  if (!props.node) {
    return <div id="avp-gestioneavp-node-section"></div>;
  }

  return (
    <div id="avp-gestioneavp-node-section">
      <div className="avp-cms-tab clearfix">
        <div className="avp-cms-tab-item avp-cms-tab-item-selected">
          Proprietà
        </div>
      </div>
      <div className="avp-cms-tab-content clearfix">
        <AvpNodePropertiesSection
          ref={nodePropertyRef}
          avp={props.avp}
          assistente={props.avpAssistente}
          node={props.node}
          tipoAvvioList={props.tipiAvvio}
          lingue={props.lingue}
          currentLingua={props.currentLingua}
          actionCallback={props.nodeActionCallback}
        />
        <AvpNodeContentSection
          ref={nodeContentRef}
          avp={props.avp}
          assistente={props.avpAssistente}
          node={props.node}
          tipoAvvioList={props.tipiAvvio}
          lingue={props.lingue}
          currentLingua={props.currentLingua}
          actionCallback={props.nodeActionCallback}
        />
      </div>
    </div>
  );
});

export default AvpNodeSection;
